import axios from 'axios';
import {
  baseUrl
} from '@/config';

export default {
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면의 자원구분정책 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRuleRsctypeList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/get-rule-rsctype-list.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면의 자원구분정책 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRuleRsctypeList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-rule-rsctype-list.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면의 자원정책 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRuleRscList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/get-rule-rsc-list.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면의 자원구분정책을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRuleRsctypeInfo(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-rule-rsctype-info.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면의 자원정책을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRuleRscInfo(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-rule-rsc-info.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 이벤트판단기준 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRuleEventRscGetintervalList() {
    return axios.get(`${baseUrl}/settings/oper/rule/get-rule-event-rsc-getinterval-list.do`);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 이벤트판단기준 목록을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRuleEventRscGetintervalList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-rule-event-rsc-getinterval-list.do`, params);
  },
  /**
   * 이벤트 판단 주기 사용 여부를 확인한다.
   * @author Ju
   * @param  {[type]} eventRscGetintervalId [description]
   * @return {[type]}                       [description]
   */
  checkUsedEventRscGetinterval(eventRscGetintervalId) {
    return axios.post(`${baseUrl}/settings/oper/rule/check-used-rule-event-rsc-getinterval.do`, { eventRscGetintervalId });
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 이벤트판단기준 목록을 삭제한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteRuleEventRscGetintervalList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/delete-rule-event-rsc-getinterval-list.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 이벤트판단기준 추가시 ID 중복여부를 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkEventRscGetintervalIdValidation(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/check-event-rsc-getinterval-id-validate.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 이벤트판단을 추가한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  insertRuleEventRscGetinterval(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/insert-rule-event-rsc-getinterval.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정관리에서 수집 설정 구분 또는 수집 설정이 자원 정책이나 장비별 자원 수집 설정에 사용 중인지 확인한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkRscGetmethodInfoInUse(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/check-rsc-getdata-info-in-use.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정관리에서 수집 설정 구분을 추가한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  insertRscGetdataType(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/insert-rsc-getdata-type`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정관리에서 수집 설정 구분을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRscGetdataType(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-rsc-getdata-type`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정관리에서 수집 설정 구분을 삭제한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteRscGetdataType(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/delete-rsc-getdata-type`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정구분 추가시 ID 중복여부를 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkRscGetdataTypeIdValidation(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/check-rsc-getdata-type-id-validate.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정 추가시 ID 중복여부를 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkRscGetdataSourceIdValidation(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/check-rsc-getdata-source-id-validate.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정관리에서 수집 설정을 추가한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  insertRscGetdataSource(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/insert-rsc-getdata-source`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정관리에서 수집 설정을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRscGetdataSource(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-rsc-getdata-source`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정관리에서 수집 설정을 삭제한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteRscGetdataSource(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/delete-rsc-getdata-source`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정의 수집 설정키 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getMappingKeyRscGetdataList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/get-mapping-key-rsc-getdata-list.do`, params);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 전체 수집 설정 키 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getMappingKeyList() {
    return axios.get(`${baseUrl}/settings/oper/rule/get-mapping-key-list.do`);
  },
  /**
   * [운영설정 > 기준정보편집] 수집/판단기준 화면 > 수집설정의 수집 설정키 목록을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateMappingKeyRscGetdataList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-mapping-key-rsc-getdata-list.do`, params);
  },
  /**
   * [성능/운영] 장비의 수집 설정 키 목록을 조회한다.
   * @author Song
   * @return {[type]}        [description]
   */
  getMappingKeyObjList(param) {
    return axios.get(`${baseUrl}/performance/get-mapping-key-obj-list.do?objId=${param.objId}`);
  },
  /**
   * [성능/운영] 장비의 수집 설정 키 정보들을 수정한다.
   * @author Song
   * @return {[type]}        [description]
   */
  updateMappingKeyObjList(param) {
    return axios.post(`${baseUrl}/performance/update-mapping-key-obj-list.do`, param);
  },
  /**
   * [성능/운영] 장비 자원의 수집 설정 정보를 조회한다.
   * @author Song
   * @return {[type]}        [description]
   */
  getRscGetdataOfObjRsc(param) {
    return axios.post(`${baseUrl}/performance/get-rsc-getdata-of-obj-rsc.do`, param);
  },
  /**
   * [성능/운영] 장비 자원의 수집 설정 키 목록을 조회한다.
   * @author Song
   * @return {[type]}        [description]
   */
  getMappingKeyObjRscList(param) {
    return axios.post(`${baseUrl}/performance/get-mapping-key-obj-rsc-list.do`, param);
  },
  /**
   * [성능/운영] 장비 자원의 수집 설정 키 값을 수정한다.
   * @author Song
   * @return {[type]}        [description]
   */
  updateMappingKeyObjRscList(param) {
    return axios.post(`${baseUrl}/performance/update-mapping-key-obj-rsc-list.do`, param);
  },
  /**
   * [성능운영 > 네트워크 장비] 햄버거 > 수집/판단 정책 화면에서 개별 정책을 저장한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateIndividualRuleInfo(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-individual-rule-info.do`, params);
  },
  /**
   * [성능운영 > 네트워크 장비] 햄버거 > 수집/판단 정책 화면에서 선택된 자원의 개별 정책을 수집/판단 정책에 적용한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  applyIndividualRscRuleList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/apply-individual-rsc-rule-list.do`, params);
  },
  /**
   * [성능운영 > 네트워크 장비] 햄버거 > 수집/판단 정책 화면에서 선택된 자원의 개별 정책을 삭제한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteIndividualRscRuleList(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/delete-individual-rsc-rule-list.do`, params);
  },
  /**
   * E2E 트랜잭션 서비스의 에이전트 리스트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getAgentByTransactionService(params) {
    return axios.get(`${baseUrl}/settings/oper/rule/get-agent-by-transaction-service.do`, {
      params,
    });
  },
  /**
   * 수집/판단 정책을 추가한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  addCollectionJudgementRule(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/add-collection-judgement-rule.do`, params);
  },
  /**
   * 수집/판단 정책을 삭제한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  deleteCollectionJudgementRule(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/delete-collection-judgement-rule.do`, params);
  },
  /**
   * 정책을 수정한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  updateRule(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/update-rule.do`, params);
  },
  /**
   * 수집/판단 정책 중복 여부를 확인한다.
   * true: 중복 / false : 중복 아님
   * @author Ju
   * @param  {String} ruleTmplId 중복 체크할 정책 아이디
   */
  checkDuplicateCollectionJudgementRule(ruleTmplId) {
    return axios.post(`${baseUrl}/settings/oper/rule/check-duplicate-collection-judgement-rule.do`, {
      ruleTmplId,
    });
  },
  /**
   * 수집판단정책(자원구분) 엑셀을 생성한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  createRuleRsctypeExcel(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/create-rule-rsctype-excel.do`, params);
  },
  /**
   * 수집판단정책(자원) 엑셀을 생성한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  createRuleRscExcel(params) {
    return axios.post(`${baseUrl}/settings/oper/rule/create-rule-rsc-excel.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/rule-settings.js